import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-profile-faq",
    templateUrl: "./profile-faq.component.html",
    styleUrls: ["./profile-faq.component.scss"]
})
export class ProfileFaqComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
